export default "__VITE_ASSET__DrrZ2qlu__"